import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faCalendarPlus } from '@fortawesome/pro-light-svg-icons'

import {
  Box, DashboardModuleListItem, Link, ListItem, Text,
} from '@domain-group/suit-theme'

import AuthenticatedDownload from '@components/AuthenticatedDownload'

import useCampaignInspection from '@hooks/useCampaignInspection'

import { confirmDelete } from '@functions/entity'

import { CampaignInspectionModel } from '@models/types'

interface CampaignInspectionListItemProps {
  campaignInspection: CampaignInspectionModel,
  readOnly?: boolean,
}

const CampaignInspectionListItem = (props: CampaignInspectionListItemProps) => {
  const { campaignInspection, readOnly } = props

  const campaignInspectionPayload = useCampaignInspection(campaignInspection)

  const {
    callbacks: {
      deleteCampaignInspection: deleteFn,
      createOrEditCampaignInspection,
    },
    campaignInspection: {
      date_parts: {
        inspection: {
          date,
          date_ordinalized,
          day,
          day_abbreviation,
          end_meridian,
          end_12hr,
          month,
          start_meridian,
          start_12hr,
        },
      },
    },
    urls: { iCalDownload },
  } = campaignInspectionPayload

  const deleteCampaignInspectionPayload = {
    callbacks: { deleteFn },
    strings: {
      entityName: 'Inspection',
    },
  }

  return (
    <ListItem boxProps={{ borderBottom: '1px dashed', justifyContent: 'space-between', padding: 'large' }} disableHover>
      <Box
        marginRight="medium"
        width="70%"
      >
        <Box
          alignItems="center"
          border="1px solid"
          borderColor="lineColor"
          borderRadius={5}
          flexDirection="column"
          height={40}
          justifyContent="center"
          width={35}
        >
          <Text color="bodyFontColor" textAlign="center" width={35}>
            {date}
          </Text>

          <Text color="mysteryGrey" fontSize="xxsmall" textAlign="center" width={35}>
            {day_abbreviation}
          </Text>
        </Box>

        <Box flexDirection="column" marginLeft="medium">
          <Text color="bodyFontColor" fontSize="small" variant="ellipsis">
            {`${day} ${date_ordinalized} ${month}`}
          </Text>

          <Box backgroundColor="whiteGrey" borderRadius={5} marginTop="small" padding="small" width="fit-content">
            <Text color="mysteryGrey" fontSize="xsmall">
              {`${start_12hr}${start_meridian} - ${end_12hr}${end_meridian}`}
            </Text>
          </Box>
        </Box>
      </Box>

      {/*
       // @ts-expect-error TS2339 */}
      <DashboardModuleListItem.Actions>
        <AuthenticatedDownload>
          <Link greyLink href={iCalDownload} target="_blank">
            <FontAwesomeIcon icon={faCalendarPlus} />
          </Link>
        </AuthenticatedDownload>

        {!readOnly && (
          <>
            {/*
             // @ts-expect-error TS2339 */}
            <DashboardModuleListItem.Icon
              boxProps={{ marginLeft: 'medium' }}
              onClick={() => createOrEditCampaignInspection()}
              type="edit"
            />

            {/*
             // @ts-expect-error TS2339 */}
            <DashboardModuleListItem.Icon
              boxProps={{ marginLeft: 'medium' }}
              onClick={() => confirmDelete(deleteCampaignInspectionPayload)}
              type="delete"
            />
          </>
        )}
        {/*
       // @ts-expect-error TS2339 */}
      </DashboardModuleListItem.Actions>
    </ListItem>
  )
}

export default CampaignInspectionListItem
